import { EquityMarketContextType } from '../types/EquityMarketContextType';

export const equityMarketInitValue: EquityMarketContextType = {
  data: {
    societyId: '',
    societyName: '',
    partnerShares: {
      total: 0,
      acquisitionValue: 0,
      avgAcquisitionPrice: 0,
      estimatedValue: 0,
      valueChange: 0,
    },
    partnerActiveOffers: {
      total: 0,
      sellCount: 0,
      buyCount: 0,
      sellAmount: 0,
      buyAmount: 0,
    },
    marketInfo: {
      totalOffers: 0,
      sellCount: 0,
      buyCount: 0,
      sellAmount: 0,
      buyAmount: 0,
    },
    sellOffers: [],
    buyOffers: [],
    sellOffersSummary: {
      offersCount: 0,
      sharesCount: 0,
      totalAmount: 0,
    },
    buyOffersSummary: {
      offersCount: 0,
      sharesCount: 0,
      totalAmount: 0,
    },
    recentActivity: [],
    referenceInfo: {
      lastValuation: 0,
      lastValuationDate: '',
      totalShares: 0,
      lastTransactionPrice: 0,
      lastTransactionDate: '',
      activePartnersInMarket: 0,
    },
    isAdmin: false,
    isReadOnly: false,
    isLoading: true,
  },
  actions: {
    handleCreateSellOffer: () => {},
    handleCreateBuyOffer: () => {},
    handleViewSellOffers: () => {},
    handleViewBuyOffers: () => {},
    handleViewOfferDetail: () => {},
    handleViewMyShares: () => {},
    handleViewMyOffers: () => {},
    handleOpenHowItWorks: () => {},
  },
};
